var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hand-right_svg__hand-right",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 724.72 504.45"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".hand-right_svg__cls-1{fill:#ffbfbf}.hand-right_svg__cls-2,.hand-right_svg__cls-4{fill:none;stroke-miterlimit:10;stroke-width:3.13px;stroke:#1d1d1b}.hand-right_svg__cls-4{stroke-linecap:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hand-right_svg__hand-right-2",
    "data-name": "hand-right"
  }, /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M986.61 940.41l-7.39-3.77s-6.87-6.12-27.25-7.22c0 0-15.4-9.45-26.5-6s-1.76 24.52 8 28.48a108.66 108.66 0 0014.34 5",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M986.61 940.41l-7.39-3.77s-6.87-6.12-27.25-7.22c0 0-15.4-9.45-26.5-6s-1.76 24.52 8 28.48a108.66 108.66 0 0014.34 5",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1086.56 1009.37l-32.2-45.69-87.44 4.71s13 5.91 35 21.83c24.92 18 56.55 78.69 56.55 78.69z",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.7 88.33l-32.2-45.7-87.45 4.72s13 5.91 35 21.83c24.92 18 56.56 78.69 56.56 78.69z",
    stroke: "#00fcac",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1089.36 1013.54s-13.89-29.2-20.78-37.28c0 0-3.61-6.25-5.37-10.45s-6.09-9-19-11.56",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M1089.36 1013.54s-13.89-29.2-20.78-37.28c0 0-3.61-6.25-5.37-10.45s-6.09-9-19-11.56",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1005.52 939.08s-8-2.52-27.78 4.24c0 0-22.86 2.2-26.93 6.54s-5.49 16.65 3.37 20.06 22.17 5.36 43.48-.69c0 0 9 9 27.66 16.08",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M1005.52 939.08s-8-2.52-27.78 4.24c0 0-22.86 2.2-26.93 6.54s-5.49 16.65 3.37 20.06 22.17 5.36 43.48-.69c0 0 9 9 27.66 16.08",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1001.94 988.45s-21.58 5.65-30.54 5.72-18.76 3.83-18.76 3.83-11 7.35-13.24 11.39c0 0-17.65 11.09-19.16 17.77s9.57 10.93 9.57 10.93a34.71 34.71 0 0033.41-13.84l3.25-.67s7.1 5.12 25.15 2.89l2.37.85s2.34 16.13 23 24.22a.43.43 0 01.25.57.41.41 0 010 .09c-.88 1.28-1.41 6.27 15.24 24.39a30 30 0 00-2.73 9.42c-.61 5.34-4.35 26.74-14.63 31.68-6.63 3.19-14.36-2-29.64-4.42-6.32-1-16.34-3.63-16.34-3.63s-8.08-10.59-27.23-18.41c-7.47-3.06-13.53-3-18.16-1.76a14.66 14.66 0 00-10.57 16.32c.92 6.25 8.56 14.27 14.1 19.46 4.13 3.86 7.55 7.41 10.27 10.42a43.89 43.89 0 0016.66 11.43 128.44 128.44 0 0025.81 6.78c16.72 2.57 55.32 32.23 65.51 40.14 23.23 18 55.79 26.68 69.06 30.89 16.91 5.36 335.17 142.33 460.93 196.69a27.39 27.39 0 0029.94-5.66c24.16-23.48 44-108.14 14-167.32a42.89 42.89 0 00-37.22-23.57c-56.42-1.42-284.84-32.84-350.54-51.2 0 0-49.27-9.45-64.51-44.93s-60.71-90.71-60.71-90.71-19.48-29.9-25.48-34.21a32.34 32.34 0 01-9.16-11l-17.24-24.07s-13.74-21.5-26.73-31l-9.87-15.3s-9.07 1.5-10 5.45-11.58 7.47 14.34 47.14c0 0 2.94 17.87 19.37 35.23a71.08 71.08 0 0018.39 34.41",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M1001.94 988.45s-21.58 5.65-30.54 5.72-18.76 3.83-18.76 3.83-11 7.35-13.24 11.39c0 0-17.65 11.09-19.16 17.77s9.57 10.93 9.57 10.93a34.71 34.71 0 0033.41-13.84l3.25-.67s7.1 5.12 25.15 2.89l2.37.85s2.34 16.13 23 24.22a.43.43 0 01.25.57.41.41 0 010 .09c-.88 1.28-1.41 6.27 15.24 24.39a30 30 0 00-2.73 9.42c-.61 5.34-4.35 26.74-14.63 31.68-6.63 3.19-14.36-2-29.64-4.42-6.32-1-16.34-3.63-16.34-3.63s-8.08-10.59-27.23-18.41c-7.47-3.06-13.53-3-18.16-1.76a14.66 14.66 0 00-10.57 16.32c.92 6.25 8.56 14.27 14.1 19.46 4.13 3.86 7.55 7.41 10.27 10.42a43.89 43.89 0 0016.66 11.43 128.44 128.44 0 0025.81 6.78c16.72 2.57 55.32 32.23 65.51 40.14 23.23 18 55.79 26.68 69.06 30.89 16.91 5.36 335.17 142.33 460.93 196.69a27.39 27.39 0 0029.94-5.66c24.16-23.48 44-108.14 14-167.32a42.89 42.89 0 00-37.22-23.57c-56.42-1.42-284.84-32.84-350.54-51.2 0 0-49.27-9.45-64.51-44.93s-60.71-90.71-60.71-90.71-19.48-29.9-25.48-34.21a32.34 32.34 0 01-9.16-11l-17.24-24.07s-13.74-21.5-26.73-31l-9.87-15.3s-9.07 1.5-10 5.45-11.58 7.47 14.34 47.14c0 0 2.94 17.87 19.37 35.23a71.08 71.08 0 0018.39 34.41",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M1051.7 1033.85a36.94 36.94 0 00-2.33 9.66c-1.17 9.9.26 26 16.16 41.32a70.71 70.71 0 0120.12 35.3 125.67 125.67 0 012 40.39",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M939.35 1009.36s5.06 3.64-3.42 11.89l-7.25 7.17s-6.52-2.92-8.43-1.28",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M939.35 1009.36s5.06 3.64-3.42 11.89l-7.25 7.17s-6.52-2.92-8.43-1.28",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M977.7 943.29a17.09 17.09 0 01-9.6 4.88c-6.19 1-12.48 5.31-12.48 5.31s-1.94-3.19-4.82-3.66",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M977.7 943.29a17.09 17.09 0 01-9.6 4.88c-6.19 1-12.48 5.31-12.48 5.31s-1.94-3.19-4.82-3.66",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M951.93 929.39s-1.43 5.34-20.52.34a9.28 9.28 0 01-5.92-6.32",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M951.93 929.39s-1.43 5.34-20.52.34a9.28 9.28 0 01-5.92-6.32",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1026.7 937.42s-9.37-4.15-14.36-12.38",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-2",
    d: "M1026.7 937.42s-9.37-4.15-14.36-12.38",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M968.94 1109.88s-7.31-3.69-13.34 13.55",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M968.94 1109.88s-7.31-3.69-13.34 13.55",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1022.62 1177.89s-5.89-9.86-4.22-34",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M1022.62 1177.89s-5.89-9.86-4.22-34M976.89 973s18.72 13 28 17.56c0 0 3.41 18.32 26.6 35.85 0 0 1.06 9-8.53 19.47",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M961.28 1125.59s-1.64 6-6.45 7.9",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M961.28 1125.59s-1.64 6-6.45 7.9",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1015 1117.68s.73 6.57-4.73 14.93",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-4",
    d: "M1015 1117.68s.73 6.57-4.73 14.93",
    transform: "translate(-911.4 -920.91)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "hand-right_svg__cls-1",
    d: "M1006.49 990.14s1.87 7.37 3 8.44 13.13 12.06 13.13 12.06l2.41-2.28s-5.49-13-6.16-13.13-12.38-5.09-12.38-5.09z",
    transform: "translate(-911.4 -920.91)"
  }))));
}
export default __webpack_public_path__ + "0a22bc0606feac3b5a12341a04d9ff08.svg";
export { SvgHandRight as ReactComponent };